<script>
    import {
        CardLayout,
        SvelteTable,
    } from "../../../Components/Common/index.svelte";

    import {
        getAmountInCurrency,
        getText,
    } from "../../../Utils/utilFunctions.svelte";

    export let billingItems = [];

    $: isItemUsingAsa =
        billingItems.length &&
        billingItems[0].itemCode !== "" &&
        billingItems[0].itemNum == 0;
    $: isItemUsingFreeText =
        billingItems.length &&
        billingItems[0].itemCode == "" &&
        billingItems[0].itemNum == 0;

    $: columns = [
        {
            key: "itemNum",
            title: "Item Num",
            headerClass: "text-left pl-3 font-bold rounded-tl-xl",
            class: "text-left px-3 w-1/12",
            isHidden: isItemUsingAsa || isItemUsingFreeText,
            value: (v) => (v.isLast ? "" : v.itemNum),
        },
        {
            key: "subItemNum",
            title: "Sub Item Num",
            headerClass: "text-left pl-3 font-bold",
            class: "text-left px-3 w-1/12",
            isHidden: isItemUsingAsa || isItemUsingFreeText,
            value: (v) => (v.isLast ? "" : v.subItemNum),
        },
        {
            key: "itemCode",
            title: "Item Code",
            headerClass: "text-left pl-3 font-bold rounded-tl-xl",
            class: "text-left px-3 w-1/12",
            isHidden: !isItemUsingAsa,
            value: (v) => (v.isLast ? "" : v.itemCode),
        },
        {
            key: "subItemCode",
            title: "Sub Item Code",
            headerClass: "text-left pl-3 font-bold",
            class: "text-left px-3 w-1/12",
            isHidden: !isItemUsingAsa,
            value: (v) => (v.isLast ? "" : v.subItemCode),
        },
        {
            key: "title",
            title: "Title",
            headerClass: "text-left px-6 font-bold",
            class: "text-left px-6 w-1/12",
            value: (v) => getText(v.title),
            isHidden: isItemUsingFreeText,
            renderValue: (v) => (v.isLast ? "" : getText(v.title)),
        },
        {
            key: "description",
            title: isItemUsingFreeText ? "Item Description" : "Description",
            headerClass: "text-left px-6 font-bold",
            class: `text-left px-6 ${isItemUsingFreeText ? "w-2/3" : "w-1/2"}`,
            renderValue: (v) =>
                v.isLast
                    ? _renderLastDescription(isItemUsingFreeText)
                    : isItemUsingFreeText
                      ? v.title
                      : v.description,
        },
        {
            key: "fee",
            title: "Fee",
            headerClass: "text-right px-6 font-bold",
            class: "text-right px-6 w-1/12",
            isHidden: isItemUsingFreeText,
            renderValue: (v) => getAmountInCurrency(v.rate),
        },
        {
            key: "gst",
            title: "GST",
            headerClass: "text-left px-6 font-bold",
            class: "text-left px-6 w-1/12",
            isHidden: isItemUsingFreeText,
            renderValue: (v) =>
                v.isLast
                    ? _renderLastDescription()
                    : getAmountInCurrency(v.tax),
        },
        {
            key: "total",
            title: isItemUsingFreeText ? "Fee Charged" : "Total",
            headerClass: "text-right px-6 font-bold rounded-tr-xl",
            class: "text-right px-6 w-1/12",
            value: (v) => getAmountInCurrency(v.totalAmount),
        },
    ];

    const handleClickCell = (
        { target: { className, classList } },
        rowData,
        key,
    ) => {};

    const handleClickCol = ({ target: { className } }, colData, key) => {};

    // HELPER FUNCTIONS
    const _renderLastDescription = (isItemUsingFreeText = false) => {
        return `<div class="flex flex-1 w-full justify-end items-center">Total Fee ${isItemUsingFreeText ? "Charged" : ""}:</div>`;
    };
</script>

<CardLayout title="Items">
    <SvelteTable
        columns={columns.filter((col) => !col.isHidden)}
        rows={billingItems}
        clickCellFunc={({ detail: { event, row, key } }) => {
            handleClickCell(event, row, key);
        }}
        clickColFunc={({ detail: { event, row, key } }) => {
            handleClickCol(event, row, key);
        }}
    />
    {#if !billingItems.length}
        <div class="grid flex-1 h-full card bg-white rounded-box">
            <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
                <p>No items in invoice</p>
            </div>
        </div>
    {/if}
</CardLayout>
